const state = {
    exchange: {
        customer: {},
        cashier: {},
        items: []
    },
    exchanges: [],
}
const actions = {
    showExchanges: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/exchanges`).then(response => {
                context.commit('SHOW_EXCHANGES', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showExchange: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/exchanges/${id}`).then(response => {
                context.commit('SHOW_EXCHANGE', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storeExchange: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/exchanges`, payload).then(response => {
                context.commit('STORE_EXCHANGE', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateExchange: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/exchanges/${payload.id}`, payload).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyExchange: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/exchanges/${id}`).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_EXCHANGE: (state, payload) => {
        state.exchange = payload
    },
    SHOW_EXCHANGES: (state, payload) => {
        state.exchanges = payload
    },
    STORE_EXCHANGE: (state, payload) => {
        state.exchange = payload
    }
}
const getters = {
    exchange: state => {
        return state.exchange
    },
    exchanges: state => {
        return state.exchanges
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}